import { Box, Dialog, Stack, DialogTitle, DialogContent, Button, CircularProgress, DialogActions, Avatar, Typography } from "@mui/material"
import { UrlApi } from "../../../../services/apirest";
import { CloudUpload, Delete, Visibility, Image, PictureAsPdf } from "@mui/icons-material";
import { useState } from "react";
import { styled } from '@mui/material/styles';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
export default function ModalArchivos(props) {
    const { modalConfig, documentos, setModalConfig, getAdjuntos, row } = props;
    const [loading, setLoading] = useState(false);

    //aca voy a guardar los datos del nuevo adjunto.
    const [formDataAdjuntos, setformdataAdjuntos] = useState([]);

    const getAdjuntoByTipo = (id_tipoadjunto) =>
        formDataAdjuntos.find((a) => a.id_tipoadjunto === id_tipoadjunto);

    //manejo la carga
    const handleFileChange = (e, id_tipoadjunto, id_provincia = null) => {
        try {
            const files = Array.from(e.target.files);
            if (files.length === 0) return;

            setformdataAdjuntos(() => {
                return files.map((file) => ({
                    nombre: file.name,
                    ruta: URL.createObjectURL(file),
                    extension: file.name.split(".").pop(),
                    nro_cuit: modalConfig.nro_cuit,
                    id_tipoadjunto,
                    id_provincia: id_tipoadjunto === 6 ? id_provincia : null,
                    file,
                }));
            });

        } catch (error) {
            console.error("Error al cargar", error);
            alert("Error al cargar el archivo");
        } finally {
            setTimeout(() => setLoading(null), 500);
            getAdjuntos(); // Refrescamos la lista
        }
    };

    // const archivoActual = documentos?.find(doc => Number(doc.id_tipoadjunto) === Number(modalConfig.tipoId));
    const archivoActual = documentos?.find(doc => {
        if (Number(modalConfig.tipoId) === 6) {
            // console.log("doc", doc);

            return (
                Number(doc.id_tipoadjunto) === 6 &&
                Number(doc.id_provincia) === Number(modalConfig.provincia)
            );
        }

        return Number(doc.id_tipoadjunto) === Number(modalConfig.tipoId);
    });

    // console.log("modalconfug", modalConfig);
    // console.log("Documentos en el Modal:", documentos);
    // console.log("Buscando Tipo ID:", modalConfig.tipoId);
    // console.log("Archivo Encontrado:", archivoActual);

    const handleEliminar = async (id) => {
        if (!window.confirm("¿Seguro que deseas eliminar este archivo?")) return;

        try {
            const res = await fetch(`${UrlApi}/uploadfiles/todownload/${id}`, { method: 'DELETE' });
            if (res.ok) {
                getAdjuntos(); // Refrescamos la lista
                alert("Eliminado correctamente");
            }
        } catch (err) {
            console.error("Error al eliminar", err);
        }
    };

    const handleSubirArchivo = async (file, tipoId, id_provincia) => {
        const formData = new FormData();
        formData.append("archivos", file);
        formData.append("nro_cuit", modalConfig.nro_cuit);
        formData.append("id_tipoadjunto", tipoId);
        formData.append("id_provincia", id_provincia);

        try {
            const res = await fetch(`${UrlApi}/uploadfiles/proveedor`, {
                method: 'POST',
                body: formData, // No enviar headers de Content-Type, fetch lo hace solo con FormData
            });
            if (res.ok) {
                getAdjuntos(); // Refrescamos la lista
                alert("Subido correctamente");
            }
        } catch (err) {
            console.error("Error al subir", err);
        }
    };

    const handleViewFile = async () => {
        setLoading(true);
        try {
            const endpoint = archivoActual.extension === "application/pdf"
                ? "/uploadfiles/uploadspdf/"
                : "/uploadfiles/uploads/";

            const response = await fetch(`${UrlApi}${endpoint}${archivoActual.nombre}`);
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);

            // Abrimos en pestaña nueva directamente
            window.open(url, "_blank", "noreferrer");
        } catch (error) {
            console.error("Error al visualizar:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={modalConfig.open}
            onClose={() => setModalConfig({ ...modalConfig, open: false })}
            fullWidth
            maxWidth="xs" // Lo hace ver más contenido y elegante
        >
            <DialogTitle sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                {archivoActual ? 'Gestión de Documento' : 'Subir Documento'}
            </DialogTitle>

            <DialogContent dividers sx={{ maxHeight: "70vh", overflowY: "auto" }}>
                <Stack spacing={2}>
                    {archivoActual ? (
                        <Box sx={{ textAlign: 'center' }}>
                            {/* Avatar/Icono del tipo de archivo */}
                            <Avatar
                                sx={{
                                    m: '0 auto', bgcolor: 'primary.light',
                                    width: 56, height: 56, mb: 2
                                }}
                            >
                                {archivoActual.extension?.includes("pdf") ? <PictureAsPdf /> : <Image />}
                            </Avatar>

                            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                {modalConfig.label}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                Archivo: {archivoActual.nombre}
                            </Typography>

                            <Stack spacing={2}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    startIcon={<Visibility />}
                                    onClick={handleViewFile}
                                    disabled={loading}
                                    sx={{ borderRadius: 2 }}
                                >
                                    {loading ? <CircularProgress size={24} color="inherit" /> : "Ver o Imprimir"}
                                </Button>

                                <Button
                                    fullWidth
                                    color="error"
                                    variant="text"
                                    startIcon={<Delete />}
                                    onClick={() => handleEliminar(archivoActual.id)}
                                    sx={{ borderRadius: 2 }}
                                >
                                    Eliminar archivo actual
                                </Button>
                            </Stack>
                        </Box>
                    ) : (
                        <>
                            {/* ZONA DE CARGA TIPO DROPZONE */}
                            <Box
                                sx={{
                                    border: "2px dashed",
                                    borderColor: "primary.main",
                                    borderRadius: 3,
                                    bgcolor: "action.hover",
                                    p: 3,
                                    textAlign: "center",
                                    cursor: "pointer",
                                    "&:hover": { bgcolor: "action.selected" },
                                }}
                                component="label"
                            >

                                <VisuallyHiddenInput
                                    type="file"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    onChange={(e) => handleFileChange(e, modalConfig.tipoId, null)}
                                />
                                <CloudUpload color="primary" sx={{ fontSize: 40, mb: 1 }} />
                                <Typography variant="h6" color="primary.main">
                                    Elegir {modalConfig.label}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    Formatos soportados: PDF, JPG, PNG
                                </Typography>

                                {loading && <CircularProgress size={24} sx={{ mt: 2, display: 'block', mx: 'auto' }} />}

                                <Button
                                    variant="contained"
                                    fullWidth
                                    sx={{ mt: 2 }}
                                    disabled={!formDataAdjuntos?.length}
                                    onClick={() =>
                                        handleSubirArchivo(
                                            formDataAdjuntos[0].file,
                                            modalConfig.tipoId,
                                            modalConfig.provincia
                                        )
                                    }
                                >
                                    Guardar adjunto
                                </Button>
                            </Box>
                        </>
                    )}
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => setModalConfig({ ...modalConfig, open: false })} color="inherit">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog >
    );
};